.container {
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.title {
  margin-top: 8px;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}
